import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box, Skeleton } from '@mui/material';
// components
import { useChart } from '../../../components/chart';
import i18n from '../../../i18n';

// ----------------------------------------------------------------------

AppWebsiteVisits.propTypes = {
    title: PropTypes.string,
    subheader: PropTypes.string,
    chartData: PropTypes.array.isRequired,
    chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};


export default function AppWebsiteVisits({ title, subheader, chartLabels, chartData, loading, ...other }) {
    const formatChartLabel = (label) => {

        const parts = label.split('-');

        const month = parts[1].padStart(2, '0');

        return parts[0] + '-' + month;
    };
    const chartLabelsAsDate = chartLabels.map(label => new Date(formatChartLabel(label)).getTime());

    const chartOptions = useChart({
        plotOptions: { bar: { columnWidth: '16%' } },
        fill: { type: chartData.map((i) => i.fill) },
        labels: chartLabelsAsDate,
        xaxis: { type: 'datetime' },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: (y) => {
                    if (typeof y !== 'undefined') {
                        return `${y.toFixed(0)} ${i18n.t('dashboard.orders')}`;
                    }
                    return y;
                },
            },
        },
    });

    return (
        <Card {...other}>
            <CardHeader
                title={
                    loading ? <Skeleton variant="text" width={180} /> : title
                }
                subheader={
                    loading && subheader ? (
                        <Skeleton variant="text" width={120} />
                    ) : (
                        subheader
                    )
                }
            />

            <Box sx={{ p: 3, pb: 1 }} dir="ltr">
                {loading ? (
                    <Skeleton variant="rounded" height={364} animation="wave" />
                ) : (
                    <ReactApexChart
                        type="line"
                        series={chartData}
                        options={chartOptions}
                        height={364}
                    />
                )}
            </Box>
        </Card>
    );
}
